"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentToolLauncher = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const sds_1 = require("@squiz/sds");
const hooks_1 = require("../../../hooks");
const ContentToolLauncher = ({ buttonText, contentTool, content, onInsertAfter, onReplace, theme, format, }) => {
    const { open } = (0, hooks_1.useContentToolDialog)(content, contentTool, onInsertAfter, onReplace);
    const buttonProps = {
        format,
        onClick: open,
        text: buttonText,
        theme,
    };
    return (0, jsx_runtime_1.jsx)(sds_1.Button, { ...buttonProps });
};
exports.ContentToolLauncher = ContentToolLauncher;
